<app-print-view
  *ngIf="applicationId"
  [printViewData]="{ applicationId: applicationId }"
></app-print-view>
